export { default as DetailsPageLoadingHeader } from "./DetailsPageLoadingHeader";
export { default as DetailsPagePlaceholderContainer } from "./DetailsPagePlaceholderContainer";
